import { Calendar } from 'react-big-calendar';

import './shadcn-big-calendar.css';

const ShadcnBigCalendar = Calendar;

export default ShadcnBigCalendar;
